var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurlyShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 87",
    width: 108,
    height: 87,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: none;stroke: #fd920f } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape 4",
    className: "shp0",
    d: "M104.98 7.3C99.49 12.78 93.44 12.4 88.59 12.1C84.26 11.83 80.84 11.62 77.58 14.87C74.33 18.11 74.54 21.52 74.81 25.84C75.11 30.69 75.49 36.72 70 42.19C64.51 47.67 58.47 47.29 53.61 46.99C49.28 46.72 45.87 46.51 42.61 49.76C39.36 53 39.57 56.41 39.84 60.73C40.15 65.58 40.52 71.61 35.03 77.08C29.55 82.56 23.5 82.18 18.65 81.88C14.32 81.61 10.9 81.39 7.64 84.64C6.28 86 4.06 86 2.69 84.64C1.32 83.28 1.32 81.07 2.69 79.7C8.18 74.22 14.22 74.6 19.08 74.9C23.41 75.17 26.83 75.39 30.08 72.14C33.33 68.89 33.12 65.48 32.85 61.16C32.55 56.32 32.17 50.29 37.66 44.81C43.15 39.34 49.19 39.72 54.05 40.02C58.38 40.29 61.8 40.5 65.05 37.25C68.3 34 68.09 30.59 67.82 26.28C67.52 21.43 67.14 15.4 72.63 9.92C78.12 4.45 84.16 4.82 89.02 5.13C93.35 5.4 96.77 5.61 100.02 2.36C101.39 1 103.61 1 104.98 2.36C106.34 3.73 106.34 5.94 104.98 7.3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurlyShape);
export default __webpack_public_path__ + "static/media/curly-shape.34a37685345187c6b8eda2b28ae40367.svg";
export { ForwardRef as ReactComponent };